
import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withWidth from '@material-ui/core/withWidth';
import { withStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import Icon from '@material-ui/core/Icon';
import ReactPlayer from 'react-player';
// import Lazyload from 'react-lazyload';
import styled from 'styled-components';
import { Link } from "routes";
import Button from '@material-ui/core/Button';
import {
  isMobile,
  isBrowser
} from "react-device-detect";
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
import SponsorFeatureBadge from '/components/sponsorFeatureBadge';
import ForwardButton from './ForwardButton';
import Lightbox from "react-image-lightbox";
import NewsItemParts from '/components/newsItemParts';

const styles = (theme) => ({
    root: {
        width: '100%',
    },
    layout: {
      margin: '-3px auto -3px',
    },
    img:{
      width: '100%',
      cursor: 'pointer'
    },
    gridList: {
      width: '100%',
    },
    titleBar: {
        backgroundColor: 'transparent',
        height: 'auto',
        marginBottom: 23,
    },
    title: {
        lineHeight: 1.2

    },
    cateStyle: {
        margin: '0px 0px 8px',
        fontSize: 12,
        marginLeft: 8,
    },
    newsTitle:{
        fontSize: 20,
        color: 'hsla(0,0%,100%,.92)',
        lineHeight: '38px',
        display: 'inline',  
        whiteSpace: 'initial',
        padding: '8px 0px'
    },

    titleWrap: {
        marginLeft: 0,
    },
    subtitle: {
        paddingLeft: 22,
        paddingRight: 22,
        marginTop: 4
    },
   
    shadow: {
      '&::before': {
        content: '""',
        width: '100%',
        position: 'absolute',
        zIndex: 1,
        // bottom: 4,
        bottom: 0,
        left: 0,
        height: 150,
        background: 'linear-gradient(0deg,rgba(0, 0, 0, 0.63) 20%,rgba(0, 0, 0, 0.51) 40%,rgba(0, 0, 0, 0.44) 49%,transparent)',
        cursor: 'pointer'
      },
    },
});

class ArticleDetailImg extends React.Component{

  constructor(props){
    super(props);
    this.state = {
      isOpen: false,
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll(event) {
    if(window.pageYOffset < 200) {
      let pImg = document.getElementById('parallax-img');
      let pWrap = document.getElementById('parallax-container');
      pImg.style.marginTop = (window.pageYOffset * -0.5)+"px";
      pImg.style.marginBottom = (window.pageYOffset * -0.2)+"px";
      pWrap.style.height = (window.parallaxOffset - (window.pageYOffset * 0.7))+"px";
    }
  }

  componentDidMount () {
    window.parallaxOffset = isMobile ? 350 : 445;
    window.addEventListener('scroll', this.handleScroll);
  }

  componentDidUpdate () {
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }  

    render(){
        const { classes, item, isServer } = this.props;
        const { isOpen } = this.state;
        const backgroundImg = "url('https://duwun-data.sgp1.cdn.digitaloceanspaces.com/static/image/broken-image-720x360.png') no-repeat center center";
        const show_fullscreen = item.show_fullscreen;
        const responsiveHeightContain = isMobile ? 270 : 330;
        const responsiveHeightCover = isMobile ? 350 : 445
        // const categoryRoute = item.category.path.split('/')[1];
        const color = item.category.color ? item.category.color: '#ed7123';
        const coverImg = item.cover.teaser && item.cover.teaser;
        return (
          <div className={classes.root}>
            <div className={classes.layout} >
              <GridList spacing={1} cols={1} rows={1} className={classes.gridList} style={{}}  >
                <GridListTile id="parallax-container" key={this.props.id} style={{padding: 0, height: responsiveHeightCover, backgroundColor: show_fullscreen ? '#535353' : 'transparent'}}>
                  <div className={classes.shadow} onClick={() => this.setState({ isOpen: true })} >
                    <SponsorFeatureBadge featured={item.featured} sponsored={item.is_sponsor} url={item.path} positionStyle={{zIndex: 1, left: 45, top: 13}} />
                    {coverImg ?
                        <div className={classes.teaser}>
                       
                            <img id="parallax-img" className={classes.img} style={{ 
                                position: 'absolute',
                                height: show_fullscreen ? responsiveHeightContain : responsiveHeightCover, 
                                objectFit: show_fullscreen ? 'contain': 'cover' , 
                                background: show_fullscreen ? 'transparent': backgroundImg }} 
                                src={coverImg} alt="" 
                                onClick={() => this.setState({ isOpen: true })} />
                          
                        </div>
                        : 
                        <img id="parallax-img" className={classes.img} style={{
                              position: 'absolute',
                              height: responsiveHeightCover,
                              objectFit: 'cover',
                              background: backgroundImg
                             }} src="https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-image-1000x500.png" alt="Duwun Logo" /> 
                    }
                     {isOpen && (
                      <Lightbox
                        mainSrc={coverImg}
                        onCloseRequest={() => this.setState({ isOpen: false })}
                      />
                    )}
                   
                  </div>
                  <ForwardButton isServer={isServer} url={this.props.url} />
                  <div style={{ position: 'absolute', bottom: 20, left: 14, zIndex: 1 }}>
                    <NewsItemParts item={item} 
                      isGraphicAndCover
                      isCover
                      color="#fff" 
                      customStyle={{
                        position: 'relative',
                        left: 8,
                        top: 5,
                        marginRight: 20
                      }}
                      customTitleStyle={{
                        background: color,
                        boxShadow: `-8px 0 0 0 ${color}, 8px 0 0 0 ${color}`,
                        color: 'hsla(0,0%,100%,.92)',
                        display: 'inline',
                        padding: '5px 0px',
                        fontSize: 20,
                        lineHeight: '35px',
                        whiteSpace: 'initial',
                        fontWeight: 400,
                      }}
                     />
                     
                  </div>
                </GridListTile>
              </GridList>
            </div>
          </div>
        );
        
    }
}


ArticleDetailImg.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(withStyles(styles), withWidth())(ArticleDetailImg);
